export default "__VITE_ASSET__Bo5$z0p___"